import { useFlutter } from '@/composables/useFlutter';

export const FlutterPlugin = {
  install(Vue, { store }) {
    const flutterApi = useFlutter(store);
    flutterApi.setupBridge();
    Vue.prototype.$logToFlutter = flutterApi.logToFlutter;
  }
};
